<div class="title">
  <div class="coldx">
    <h4 *ngIf="!formEdit">Inserimento Società</h4>
    <h4 *ngIf="formEdit">Modifica Società</h4>
  </div>
</div>

<form [formGroup]="newcompanyForm">
  <div class="form-row">
    <div class="col-sm-4">
      <div class="form-group"><label for="">Nome</label><span _ngcontent-c10="" class="mandatory ">*</span>
        <input placeholder="Inserisci nome società " formControlName="name" id="" autocomplete="organization" type="text"
               class="form-control">
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="type">Tipo Società</label> <span class="mandatory ">*</span>
        <select class="form-control" type="text" formControlName="type">
          <option
            [ngValue]="(formData)?formData.type: null"> {{(formData) ? formData.type.name : "Seleziona tipo società" }} </option>
          <option *ngFor="let type of types " [title]="type.name" [ngValue]="type"> {{type.name}} </option>
        </select>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="type">Tipo sede</label> <span _ngcontent-c10="" class="mandatory ">*</span>
        <select class="form-control" type="text" formControlName="scope">
          <option
            [ngValue]="(formData)?formData.scope: null"> {{(formData) ? formData.scope.name : "Seleziona tipo sede" }}  </option>
          <option *ngFor="let type of scopes " [title]="type.name" [ngValue]="type">{{type.name}}
          </option>
        </select>
      </div>
    </div>
  </div>

  <div class="form-row">
    <div class="col-sm-6 form-group">
      <label for="">Stato</label>
      <span _ngcontent-c10="" class="mandatory ">*</span>
      <select class="form-control" formControlName="status">
        <option [value]="null">---</option>
        <option *ngFor="let opt of statuses" [value]="opt.id"
                [selected]="formEdit ? opt.id === newcompanyForm.get('status').value : false">{{opt.name}}</option>
      </select>
    </div>
    <div class="col-sm-6 form-group">
      <label for="">Data decorrenza dello stato</label>
      <span _ngcontent-c10="" class="mandatory ">*</span>
      <input formControlName="statusDate" type="date" class="form-control"
             [valueAsDate]="newcompanyForm.get('statusDate').value" datePickerInput>
    </div>
  </div>

  <div class="form-row">
    <div [ngClass]="{'col-sm-4' : personSelected , 'col-sm-12' : !personSelected }">
      <div class="form-group">
        <label for="type">Proprietario</label> <span class="mandatory ">*</span>
        <!-- <input id="owner"  list="owner" class="form-control custom-select custom-select-sm" name="owner"   > -->
        <select (change)="autofillData()" class="form-control" formControlName="owner" id="owner">
          <option *ngIf="!personSelected" [ngValue]="null">Seleziona Proprietario</option>
          <option *ngFor="let person of persons" [ngValue]="person">
            <strong *ngIf="person.name">{{person.name}}</strong>
            <strong *ngIf="person.firstName">{{person.firstName}}</strong>
            <strong>{{"--" + person.taxNumber}}</strong>
          </option>
        </select>
      </div>
    </div>
    <div class="col-sm-8">
      <div class="form-row" *ngIf="personSelected">
        <label>Dettaglio Proprietario</label>

        <div class="form-row">
          <div class="col-sm-6 form-group">
            <label for="">Tipo persona</label>
            <input disabled [value]="personSelected.type" id="" placeholder="Inserire tipo persona" type="text" class="form-control">
          </div>
          <div class="col-sm-6 form-group">
            <label for="">Codice fiscale</label>
            <input disabled [value]="personSelected.taxNumber" placeholder="inserire codice fiscale" id="" type="text" class="form-control">
          </div>
        </div>
        <ng-container *ngIf="personSelected.type === 'LEGAL_ENTITY'">
          <div class="form-row">
            <div class="col-sm-6 form-group">
              <label for="">Nome</label>
              <input disabled [value]="personSelected.name" placeholder="inserire nome" id="" type="text" class="form-control">
            </div>
            <div class="col-sm-6 form-group">
              <label for="">Partita IVA</label>
              <input disabled [value]="personSelected.vatNumber" placeholder="inserire partita IVA" id="" type="text" class="form-control">
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="personSelected.type === 'PHYSICAL_ENTITY'">
          <div class="form-row">
            <div class="col-sm-6 form-group">
              <label for="">Nome</label>
              <input disabled [value]="personSelected.firstName" placeholder="inserire nome" id="" type="text" class="form-control">
            </div>
            <div class="col-sm-6 form-group">
              <label for="">Cognome</label>
              <input disabled [value]="personSelected.lastName" placeholder="inserire cognome" id="" type="text" class="form-control">
            </div>
          </div>
          <div class="form-row">
            <div class="col-sm-6 col-sm-offset-6 form-group">
              <label for="">Email</label>
              <input disabled [value]="personSelected.email" placeholder="inserire email" id="" name="email" autocomplete="email" type="text" class="form-control">
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="form-row">
    <div class="col-sm-12">
      <div class="form-group">
        <label for="">Partita IVA</label>
        <span _ngcontent-c10="" class="mandatory ">*</span>
        <input formControlName="vatNumber" type="text" class="form-control"
               placeholder="Inserisci partita IVA "
               (focusout)="errorCheck()"
        >
        <small *ngIf="vatNumberCheck" class="text-danger">
          Inserire almeno 11 caratteri
        </small>
      </div>
    </div>
  </div>

  <p class="col-md-12 mandatory"><em>* Campi obbligatori</em></p>
  <div class="form-row">
    <div class="col-xs-12 col-sm-6"></div>

    <div class="col-xs-6 col-sm-3">
      <button type="button" class="btn btn-outline-secondary btn-block" (click)="formReset()">Reset</button>
    </div>
    <div *ngIf="!formEdit" class="col-xs-6 col-sm-3">
      <button type="submit" (click)="onSaveCompany()" [disabled]="!newcompanyForm.valid"
              class="btn btn-primary btn-block   ">Inserisci</button>
    </div>
    <div *ngIf="formEdit" class="col-xs-6 col-sm-3">
      <button type="submit" (click)="onEditComplete()" [disabled]="!newcompanyForm.valid"
              class="btn btn-primary btn-block   ">Salva</button>
    </div>
  </div>

</form>


